import { useEffect, useState } from "react";
import { api, FirmConfig, Manifest } from "../api";

export default function ConfigStudio(_: { manifest: Manifest }) {
  const [version, setVersion] = useState(0);
  const [text, setText] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const c = await api.get<FirmConfig>("/api/firm/config");
        setVersion(c.version);
        setText(JSON.stringify(c.config, null, 2));
      } catch (e) { setError((e as Error).message); }
    })();
  }, []);

  async function save() {
    setBusy(true);
    setError(null);
    setSaved(false);
    let parsed: unknown;
    try {
      parsed = JSON.parse(text);
    } catch {
      setError("invalid JSON");
      setBusy(false);
      return;
    }
    try {
      const c = await api.put<FirmConfig>("/api/firm/config", { config: parsed, note: note || undefined });
      setVersion(c.version);
      setText(JSON.stringify(c.config, null, 2));
      setNote("");
      setSaved(true);
    } catch (e) { setError((e as Error).message); }
    finally { setBusy(false); }
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-bold">Config Studio</h1>
        <span className="badge bg-accent/20 text-accent">v{version}</span>
      </div>
      <p className="text-sm text-slate-400">
        The firm&rsquo;s behavior: agent rosters and model bindings, desk cadence and universe,
        schedule, soft risk limits, panels. Saving publishes a new immutable version.
        Secrets never go here — use Connections. Env risk floors always win over soft limits.
      </p>
      {error && <div className="text-down text-sm">{error}</div>}
      {saved && <div className="text-up text-sm">saved as v{version}</div>}
      <textarea
        className="input font-mono h-[32rem] text-xs"
        value={text}
        onChange={(e) => { setText(e.target.value); setSaved(false); }}
        spellCheck={false}
      />
      <div className="flex gap-2">
        <input className="input max-w-md" placeholder="version note"
               value={note} onChange={(e) => setNote(e.target.value)} />
        <button className="btn btn-primary" onClick={save} disabled={busy}>
          {busy ? "…" : "Publish new version"}
        </button>
      </div>
    </div>
  );
}
